(function () {
  var TIMEOUT_MS = 7000; // fallback: show whatever exists after 7s
  var SETTLE_MS  = 400;  // wait after WhatsApp injects so its own animation runs silently
  var done = false;

  function showBoth() {
    if (done) return;
    done = true;
    var lang = document.querySelector('#gt_float_wrapper');
    var wa   = document.querySelector('#cx_whatsapp_init');
    if (lang) lang.classList.add('mtrx-widget-show');
    if (wa)   wa.classList.add('mtrx-widget-show');
  }

  function onWaInjected() {
    observer.disconnect();
    clearTimeout(fallback);
    setTimeout(showBoth, SETTLE_MS);
  }

  var fallback = setTimeout(showBoth, TIMEOUT_MS);

  var observer = new MutationObserver(function () {
    if (document.querySelector('#cx_whatsapp_init > *')) onWaInjected();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // In case button already exists on script run
  if (document.querySelector('#cx_whatsapp_init > *')) onWaInjected();
})();
